jQuery(function ($) {
  "use strict";

  const isSP = window.matchMedia("(max-width: 767.98px)").matches;
  if (!isSP) return;

  document.querySelectorAll(".sp-gallery").forEach((gallery) => {
    const mainWrap = gallery.querySelector(".sp-gallery__main");
    const thumbs = gallery.querySelectorAll(".sp-gallery__thumb");

    const imgA = mainWrap.querySelector("img");
    const imgB = imgA.cloneNode();
    imgB.classList.add("is-back");
    mainWrap.appendChild(imgB);

    let currentIndex = 0;
    let isAnimating = false;

    function changeImage(index) {
      if (isAnimating) return;
      isAnimating = true;

      const target = thumbs[index];

      imgB.src = target.src;
      imgB.alt = target.alt;

      thumbs.forEach((t) => t.classList.remove("is-active"));
      target.classList.add("is-active");

      imgA.classList.add("is-fade");

      setTimeout(() => {
        imgA.src = imgB.src;
        imgA.alt = imgB.alt;
        imgA.classList.remove("is-fade");

        currentIndex = index;
        isAnimating = false;
      }, 600);
    }

    setInterval(() => {
      const nextIndex = (currentIndex + 1) % thumbs.length;
      changeImage(nextIndex);
    }, 5000);
  });
});
